import React from 'react';
import { EiqDatePicker } from 'eiq-storybook';
import moment from 'moment';

import { toFullUtcDateString } from 'utils/format/date';
import s from 'src/components/CapFieldsNew/CapEditField.styles';

const CapEditDatepickerField = ({
  disabled,
  placeholderText,
  wrapperClassName,
  selectedDate,
  onChange,
  error
}) => {
  const popperModifiers = {
    flip: {
      enabled: false,
    },
    preventOverflow: {
      enabled: true,
      escapeWithReference: false,
    },
  };

  const changeFromDateAsUTC = (date) => {
    const tmpMoment = moment(date).toDate();
    return `${tmpMoment.getFullYear()}-${tmpMoment.getMonth()+1}-${tmpMoment.getDate()} 00:00:00`;
  };

  return (<>
    <EiqDatePicker
      placeholderText={placeholderText}
      wrapperClassName={wrapperClassName}
      selectedDate={selectedDate ? toFullUtcDateString(selectedDate) : null}
      disabled={disabled}
      autoComplete="off"
      dateFormat={'dd-MMM-yyyy'}
      onChange={(value) => onChange(changeFromDateAsUTC(value))}
      popperModifiers={popperModifiers}
      popperPlacement="bottom-end"
      showTimeSelect={false}
      styles={{ width: '100%' }}
    />
    
    {error && (
      <s.DatePickerFieldError>{error}</s.DatePickerFieldError>
    )}
    </>
  );
}

export default React.memo(CapEditDatepickerField);